import React, {Component} from 'react'
import {Button, Modal, Table} from "semantic-ui-react";


class ListOfLockedProvidersModal extends Component{
    constructor(props) {
        super(props);
    }



    render() {
        const {lockedProvidersModalData, modalContent,handleSort, hideLockedProvidersModal, column, order, direction,lockedProvidersModal} = this.props;

        return (<Modal
            onClose={() => hideLockedProvidersModal(false)}
            open={lockedProvidersModal}
            size= 'large'
            closeIcon
        >
            <Modal.Header>List of locked Doctors ({lockedProvidersModalData.length})</Modal.Header>
            <Modal.Content scrolling>
                <div className="table-responsive overflow-unset">
                    <Table compact celled className="table table-striped table-hover TableHeaderFixed my-0">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className={`cursorPointer ${column === 'provider' ? 'active': ''}`} onClick={handleSort('provider')}>
                                    ABBR
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </Table.HeaderCell>
                                <Table.HeaderCell className={`cursorPointer ${column === 'firstName' ? 'active': ''}`} onClick={handleSort('firstName')}>
                                    First Name
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </Table.HeaderCell>
                                <Table.HeaderCell className={`cursorPointer ${column === 'lastName' ? 'active': ''}`} onClick={handleSort('lastName')}>
                                    Last Name
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </Table.HeaderCell>
                                <Table.HeaderCell>Open Dental</Table.HeaderCell>
                                <Table.HeaderCell>Provider Profile</Table.HeaderCell>
                                <Table.HeaderCell>Fin Notes</Table.HeaderCell>
                                <Table.HeaderCell>Schedule</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {modalContent}
                        </Table.Body>
                    </Table>
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    icon='check'
                    content='Close'
                    onClick={() =>hideLockedProvidersModal()}
                />
            </Modal.Actions>
        </Modal>);
    }
}

export default ListOfLockedProvidersModal;
